import { Container as MuiContainer } from "@mui/material";

export function Container(props: any) {
  return <MuiContainer {...props} style={{...props.style, maxWidth: undefined}} />;
}
